import {z} from 'zod';

export const FieldDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const StageDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const FieldGroupDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  fields: z.array(FieldDefinitionSchema),
  allowedStageIds: z.array(z.string()).nullish(),
});

export const StageSequenceDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  stages: z.array(StageDefinitionSchema),
});

export const MandatoryFieldsDefinitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  fieldGroups: z.array(FieldGroupDefinitionSchema),
  stageSequences: z.array(StageSequenceDefinitionSchema),
});

export const MandatoryFieldsDefinitionListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const MandatoryFieldsDefinitionListSchema = z.object({
  definitions: z.array(MandatoryFieldsDefinitionListItemSchema),
});

export const GetMandatoryFieldsDefinitionArgSchema = z.object({
  definitionId: z.string(),
});

export const GetMandatoryFieldsDefinitionListArgSchema = z.object({});

export const MandatoryFieldSchema = z.object({
  fieldId: z.string(),
  stageId: z.string(),
});

export const StageSequenceMandatoryFieldsSchema = z.object({
  stageSequenceId: z.string(),
  mandatoryFields: z.array(MandatoryFieldSchema),
});

export const MandatoryFieldRequestSchema = z.object({
  fieldId: z.string(),
  stageId: z.string(),
});

export const StageSequenceMandatoryFieldsRequestSchema = z.object({
  mandatoryFields: z.array(MandatoryFieldRequestSchema),
});

export const GetStageSequenceMandatoryFieldsArgSchema = z.object({
  definitionId: z.string(),
  stageSequenceId: z.string(),
});

export const SetStageSequenceMandatoryFieldsArgSchema = z.object({
  definitionId: z.string(),
  stageSequenceId: z.string(),
  stageSequenceMandatoryFieldsRequestBody: StageSequenceMandatoryFieldsRequestSchema,
});

export const GetStageSequenceMandatoryFieldsListArgSchema = z.object({
  definitionId: z.string(),
});

export type StageSequenceMandatoryFieldsListResponseBody = {
  stageSequences: StageSequenceMandatoryFieldsResponseBody[];
};
export type GetStageSequenceMandatoryFieldsListApiResponse =
  StageSequenceMandatoryFieldsListResponseBody;
export type GetStageSequenceMandatoryFieldsListApiArg = z.infer<
  typeof GetStageSequenceMandatoryFieldsListArgSchema
>;

export type MandatoryFieldResponseBody = z.infer<typeof MandatoryFieldSchema>;
export type StageSequenceMandatoryFieldsResponseBody = z.infer<
  typeof StageSequenceMandatoryFieldsSchema
>;

export type MandatoryFieldRequestBody = z.infer<typeof MandatoryFieldRequestSchema>;
export type StageSequenceMandatoryFieldsRequestBody = z.infer<
  typeof StageSequenceMandatoryFieldsRequestSchema
>;
export type GetStageSequenceMandatoryFieldsApiResponse = z.infer<
  typeof StageSequenceMandatoryFieldsSchema
>;
export type GetStageSequenceMandatoryFieldsApiArg = z.infer<
  typeof GetStageSequenceMandatoryFieldsArgSchema
>;
export type SetStageSequenceMandatoryFieldsApiResponse = void;
export type SetStageSequenceMandatoryFieldsApiArg = z.infer<
  typeof SetStageSequenceMandatoryFieldsArgSchema
>;

export type FieldDefinitionResponseBody = z.infer<typeof FieldDefinitionSchema>;
export type StageDefinitionResponseBody = z.infer<typeof StageDefinitionSchema>;
export type FieldGroupDefinitionResponseBody = z.infer<typeof FieldGroupDefinitionSchema>;
export type StageSequenceDefinitionResponseBody = z.infer<typeof StageSequenceDefinitionSchema>;
export type MandatoryFieldsDefinitionResponseBody = z.infer<typeof MandatoryFieldsDefinitionSchema>;
export type MandatoryFieldsDefinitionListItemResponseBody = z.infer<
  typeof MandatoryFieldsDefinitionListItemSchema
>;
export type MandatoryFieldsDefinitionListResponseBody = z.infer<
  typeof MandatoryFieldsDefinitionListSchema
>;
export type GetMandatoryFieldsDefinitionApiArg = z.infer<
  typeof GetMandatoryFieldsDefinitionArgSchema
>;
export type GetMandatoryFieldsDefinitionApiResponse = MandatoryFieldsDefinitionResponseBody;
export type GetMandatoryFieldsDefinitionListApiArg = z.infer<
  typeof GetMandatoryFieldsDefinitionListArgSchema
>;
export type GetMandatoryFieldsDefinitionListApiResponse = MandatoryFieldsDefinitionListResponseBody;
